import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const AgentChatMessageLoader: React.FC = () => (
  <div className="mx-2 w-4/5 h-18 py-1 px-2 flex flex-col rounded self-start bg-litlingo-gray-1 text-body">
    <SkeletonTheme baseColor="#DDDDDD" highlightColor="#EEEEEE">
      <Skeleton containerClassName="flex-1" count={3} />
    </SkeletonTheme>
  </div>
);

export default AgentChatMessageLoader;
